import { createState } from '../../lib/create-state';

export type LottieEffectState = {
    activeEffect: string | null;
    activeEffectKey: number;
    queuedEffects: string[];
};

export const [lottieEffect, resetLottieEffect] = createState<LottieEffectState>(
    {
        activeEffect: null,
        activeEffectKey: 0,
        queuedEffects: [],
    }
);

export const enqueueLottieEffect = (effect: string) => {
    lottieEffect.set((state) => {
        if (!state.activeEffect) {
            return {
                ...state,
                activeEffect: effect,
                activeEffectKey: state.activeEffectKey + 1,
            };
        }

        return {
            ...state,
            queuedEffects: [...state.queuedEffects, effect],
        };
    });
};

export const playNextLottieEffect = () => {
    lottieEffect.set((state) => {
        const [nextEffect, ...queuedEffects] = state.queuedEffects;

        return {
            ...state,
            activeEffect: nextEffect || null,
            activeEffectKey: nextEffect
                ? state.activeEffectKey + 1
                : state.activeEffectKey,
            queuedEffects,
        };
    });
};
